import { axios, urlList } from '../index'
let scopeUrl = ''
// 微服务地址
// let scopeUrl = 'http://192.168.1.25:21601'
// scopeUrl = 'http://116.62.171.11:21601' // lipan
// scopeUrl = 'http://192.168.1.83:21601' // lipan

let scope = scopeUrl ? `${scopeUrl}/workflow` : '/workflow'

export default {
  // 业务需要添加cancel方法
  cancel: function () {
      axios.cancel()
  },
  // form 表单信息
  form: {
    getFormModelByKey(formkey) {
      return axios.post(`${scope}/form/getFormModelByKey`, formkey)
    },
  },

  // 新建实例
  process: {
    // 获取全部流程类型
    getProcessType() {
      return axios.get(`${scope}/process/getProcessType`)
    },
    // 获取当前用户的流程类型
    getProcessTypeByUserId(userId) {
      return axios.get(`${scope}/process/getProcessTypeByUserId/${userId}`)
    },
    /**
     * 新建流程
     * @param {object} params
     * @param {string} params.initiator
     * @param {string} params.processBusinessKey
     * @param {string} params.processInstanceName
     * @param {string} params.processScopeId
     * @param {object} params.variables
     */
    newProcessInstance(params) {
      return axios.post(`${scope}/process/startProcessInstanceWithForm`, params)
    },
    // hanpan517
    // 应收账单删改流程
    newDeleteModify(params) {
      return axios.post(`${scope}/process/startProcessInstanceWithForm`, params)
    },
    // 获取退租办理列表数据
    getLeasePreSettlement(params) {
      return axios.post(
        urlList.rent + `leasePreSettlement/preSettlement`,
        params
      )
    },
    // 历史提交的表单信息
    getProcessedFormData(params) {
      return axios.post(`${scope}/process/getProcessedFormData`, params)
    },
    // @ {String} processInstanceId 获取分步的流程信息
    getHistoryActivityInfo(params) {
      return axios.post(`${scope}/process/getHistoryActivityInfo`, params)
    },
    // 我处理的流程
    getMyFinishedProcessInstance(params) {
      return axios.post(`${scope}/process/getMyFinishedProcessInstance`, params)
    },
    // 我发起的流程
    getMyStartedProcessInstance(params) {
      return axios.post(`${scope}/process/getMyStartedProcessInstance`, params)
    },
    //  流程查询接口
    getAdminProcessInstance(params) {
      return axios.post(`${scope}/process/getAdminProcessInstance`, params)
    },
    // 导出按钮接口
    // exportExcelInterface(params) {
    //   return axios.post(`/datawarehouse/workflow/expect/expect`, params)
    // },
    // 维修流程 获取维修项目 三级下拉数据
    getMaintainThingMessage(params) {
      return axios.post(
        `${scope}/process/business/repair/getRepairBusinessTree`,
        params
      )
    },
    // 根据 房源ID 获取对应的 管家信息
    getHouseKeeperInformByHouseId(id) {
      return axios.get(`${scope}/process/business/get/housekeeper/${id}`)
    },
    getProcessVariables(processInstanceId) {
      return axios.get(
        `${scope}/process/getProcessVariables/${processInstanceId}`
      )
    },
  },
  task: {
    getTasklist(params) {
      return axios.post(`${scope}/task/getPendingTask`, params)
    },
    getTask(taskId) {
      return axios.post(`${scope}/task/getSingleTaskInfo/${taskId}`)
    },
    claim(params) {
      return axios.post(`${scope}/task/claim`, params)
    },
    // 任务放回
    unclaim(params) {
      return axios.post(`${scope}/task/unclaim`, params)
    },
    updateTask(params) {
      return axios.post(`${scope}/task/completeTaskWithForm`, params)
    },
    getActivityFormData(params) {
      return axios.post(`${scope}/process/getActivityFormData`, params)
    },
    // 维保 移交
    transferMaintainUser(taskId, userId, oldUserId) {
      return axios.get(
        `${scope}/task/transferAssignee/${taskId}/${userId}/${oldUserId}`
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/xhr/services/workflow.js